import styled from 'styled-components';
import { Card } from '../../../../../ui-toolkit/components';

//for fans of GrayLine:
export const GrayCard = styled(Card)`
  background-color: ${(props) => props.theme.colors.lightGray};
`;
